export const SET_LOGS = 'SET_LOGS';
export const SET_FETCHING_LOGS = 'SET_FETCHING_LOGS';
export const SET_LOGS_ERROR = 'SET_LOGS_ERROR';
export const SET_FINANCIAL_LOGS_VISIBLE = 'SET_FINANCIAL_LOGS_VISIBLE';
export const SET_FORM_LOGS_VISIBLE = 'SET_FORM_LOGS_VISIBLE';